import type { ApiClient } from "@riea-water/api-client";
import type { Me, ModulesResponse } from "@riea-water/contracts";
import { useMemo } from "react";
import { Outlet } from "react-router";
import { Banner } from "./Banner.js";
import { buildNav, type NavSection } from "./nav.js";
import { SideNav } from "./SideNav.js";
import { TopBar } from "./TopBar.js";

/** What every screen reads from the shell (rule 1: data only through the client). */
export interface ShellContext {
  me: Me;
  modules: ModulesResponse;
  sections: NavSection[];
  client: ApiClient;
  getToken: () => Promise<string | null>;
}

export function Shell(props: {
  me: Me;
  modules: ModulesResponse;
  demo: boolean;
  links?: { rieaPro?: string | undefined; hes?: string | undefined } | undefined;
  client: ApiClient;
  getToken: () => Promise<string | null>;
  onSignOut: () => void;
}) {
  const sections = useMemo(
    () => buildNav(props.modules, props.me.role),
    [props.modules, props.me.role],
  );
  return (
    <div className="app">
      <TopBar
        me={props.me}
        onSignOut={props.onSignOut}
        links={props.links}
        getToken={props.getToken}
      />
      <Banner me={props.me} demo={props.demo} />
      <SideNav sections={sections} />
      <main id="main">
        <Outlet
          context={
            {
              me: props.me,
              modules: props.modules,
              sections,
              client: props.client,
              getToken: props.getToken,
            } satisfies ShellContext
          }
        />
      </main>
    </div>
  );
}
